import { Icon, Text } from '@shopify/polaris';
import { InfoIcon } from '@shopify/polaris-icons';

const ErrorHelperText = ({ message }: { message?: string }) => {
  return message ? (
    <div className="d-flex align-center gap-4">
      <Icon source={InfoIcon} tone="critical" />
      <Text as="p" variant="bodyMd" tone="critical">
        {message}
      </Text>
    </div>
  ) : null;
};

export default ErrorHelperText;
